import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import WarningRoundedIcon from '@material-ui/icons/WarningRounded';
import useStyles from './style';

const UnsavedChangesDialog = ({
    open,
    title = 'Unsaved changes',
    message = 'You have unsaved changes. Are you sure you want to leave this page?',
    onStay,
    onLeave,
}) => {
    const classes = useStyles();

    return (
        <Dialog
            open={open}
            onClose={onStay}
            disableBackdropClick
            disableEscapeKeyDown
            classes={{ paper: classes.paper }}
            aria-labelledby="unsaved-changes-dialog-title"
            aria-describedby="unsaved-changes-dialog-message"
        >
            <DialogContent className={classes.content}>
                <div className={classes.iconWrap}>
                    <WarningRoundedIcon className={classes.icon} />
                </div>
                <Typography variant="h6" id="unsaved-changes-dialog-title" className={classes.title}>
                    {title}
                </Typography>
                <Typography variant="body2" id="unsaved-changes-dialog-message" className={classes.message}>
                    {message}
                </Typography>
            </DialogContent>
            <DialogActions className={classes.actions}>
                <Button onClick={onStay} className={classes.stayButton} variant="outlined">
                    Stay
                </Button>
                <Button onClick={onLeave} className={classes.leaveButton} variant="contained" autoFocus>
                    Leave without saving
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default UnsavedChangesDialog;
